import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white border-t mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-sm text-gray-600">
            ©2025 - UPnGOTrainerPad
          </div>
          <div className="flex flex-wrap justify-center md:justify-end gap-4 text-sm text-gray-600">
            <Link to="/privacy-policy" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-primary transition-colors">
              Terms & Services
            </Link>
            <Link to="/documentation" className="hover:text-primary transition-colors">
              Documentation
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;